import { format } from "date-fns";

export const DEFAULT_DATE_FORMAT = "MM/dd/yyyy";
export const DEFAULT_FULL_DATE_FORMAT = "MMM dd, yyyy";

export const formatDate = (date: Date, dateFormat = DEFAULT_DATE_FORMAT) => {
  if (date) {
    return format(date, dateFormat)
  }
  return ''
}
